import { useState, useEffect } from 'react'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import { ReactComponent as Loading } from 'icons/loading2.svg'
// import * as FA from 'react-icons/fa'

import {
  SubContainer,
  // RatingContainer,
  ProfessionalPicture,
  Column,
  Row,
  ProfessionalsGrid,
  SmallButton,
  SubTitle
} from '../styles'

export default function ProfessionalsForm ({
  schedule = {},
  onProceed: handleProceed = () => null
}) {
  const [loading, setLoading] = useState (true)
  const [professionals, setProfessionals] = useState ([])
  const { business, service, date, time } = schedule
  
  useEffect (() => {
    getProfessionals ()
  }, [])

  const getProfessionals = async () => {
    const filters = `access_level=service&status=active&deleted=false&schedule_id=${schedule.id}`
                  + `&service_id=${service.id}&accepts_online=true`
                  + `&schedule_date=${date}&schedule_time=${time}`

    try {
      const { data: professionals } = await cutileiApi.get (
        `/businesses/${business.id}/professionals?${filters}`,
        { anonymous: true }
      )
      setProfessionals (professionals)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  return (
    <SubContainer>
      <SubTitle>Escolha o(a) profissional</SubTitle>
      {loading ? (
        <Loading style={{marginTop: 20}}/>
      ) : (
        <ProfessionalsGrid>
          {professionals.map ((professional, index) => (
            <SmallButton
              key={index}
              onClick={() => handleProceed ({ professional })}
              style={{margin: 0}}
            >
              <Column>
                <Row style={{position: 'relative', marginBottom: 4}}>
                  <ProfessionalPicture src={professional.profile_picture}/>
                  {/* {professional.average_rating > 0 && (
                    <RatingContainer>
                      <FA.FaStar size={14} color='#FFC100'/>
                      <SubTitle>
                        {professional.average_rating}
                      </SubTitle>
                    </RatingContainer>
                  )} */}
                </Row>
                <SubTitle>
                  {professional.nickname}
                </SubTitle>
              </Column>
            </SmallButton>
          ))}
        </ProfessionalsGrid>
      )}
    </SubContainer>
  )
}
